import Reveal from "./Reveal";

const SERVICES = [
  {
    n: "01",
    title: "Despacho de Importação",
    desc: "Registro de DI/DUIMP, conferência documental e liberação da carga em portos, aeroportos e fronteiras.",
  },
  {
    n: "02",
    title: "Despacho de Exportação",
    desc: "Declarações de exportação, averbações e acompanhamento do embarque até a saída da mercadoria.",
  },
  {
    n: "03",
    title: "Assessoria Aduaneira",
    desc: "Planejamento tributário e operacional para reduzir custos e riscos nas operações de comércio exterior.",
  },
  {
    n: "04",
    title: "Habilitação no Siscomex",
    desc: "RADAR, credenciamento e regularidade da sua empresa junto à Receita Federal do Brasil.",
  },
  {
    n: "05",
    title: "Licenças e Anuências",
    desc: "Licenças de importação, LPCO e certificados junto aos órgãos anuentes do comércio exterior.",
  },
];

const Services = () => (
  <section id="servicos" className="px-6 py-24 lg:px-12 lg:py-36" data-testid="services-section">
    <Reveal>
      <div className="mb-16 flex flex-col gap-4 lg:mb-24">
        <span className="font-mono text-xs uppercase tracking-[0.35em] text-ink/50">
          01 / Serviços
        </span>
        <h2 className="max-w-4xl font-oswald text-4xl font-bold uppercase leading-none tracking-tight sm:text-5xl lg:text-7xl">
          Tudo que a sua carga precisa para cruzar a fronteira
        </h2>
      </div>
    </Reveal>

    <div>
      {SERVICES.map((s, i) => (
        <Reveal key={s.n} delay={i * 0.05}>
          <div
            className={`group grid grid-cols-12 items-baseline gap-4 border-t border-ink/15 px-2 py-10 transition-colors duration-300 hover:bg-navy lg:py-12 ${
              i === SERVICES.length - 1 ? "border-b" : ""
            }`}
            data-testid={`service-row-${s.n}`}
          >
            <span className="col-span-2 font-mono text-sm text-ink/40 transition-colors duration-300 group-hover:text-ink/50 lg:col-span-1">
              {s.n}
            </span>
            <h3 className="col-span-10 font-oswald text-2xl font-semibold uppercase tracking-tight transition-colors duration-300 group-hover:text-white sm:text-3xl lg:col-span-5 lg:text-4xl">
              {s.title}
            </h3>
            <p className="col-span-10 col-start-3 text-sm font-light leading-relaxed text-ink/60 transition-colors duration-300 group-hover:text-white/70 lg:col-span-5 lg:col-start-8 lg:text-base">
              {s.desc}
            </p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);

export default Services;
